<template>
    <van-popup v-model="show" position="bottom" :style="{ height: '70%' }" round>
        <div class="pop-sku-wrap">
            <div class="title">选择商品规格</div>

            <div class="main">
                <div class="info">
                    <div class="cover">
                        <img :src="goodsInfo.cover" alt="" />
                    </div>

                    <!-- <div class="price">
                        <span>￥</span>
                        <span>{{ getPrice(options[checked - 1].text) }}</span>
                    </div> -->
                </div>
                <div class="checkbox">
                    <van-radio-group v-model="checked">
                        <van-radio :name="item.id" v-for="(item, index) in goodsInfo.skuList" :key="index">
                            <div :class="['check-btn', checked == item.id ? 'active' : '']">
                                {{ item.name }}
                                <span>￥</span> {{ item.price }}
                                <!-- {{ getType(item.text) }}
                                    

                                // <span>￥</span>{{ getPrice(item.text) }} -->
                            </div>
                        </van-radio>
                    </van-radio-group>
                </div>
            </div>
            <div class="btn" @click="onConfirm">确定</div>
        </div>
    </van-popup>
</template>

<script>
export default {
    props: {
        goodsInfo: Object,
    },
    data() {
        return {
            show: false,
            checked: null,
        }
    },

    computed: {
        options() {
            let arr = []

            if (this.goodsInfo.remark) {
                this.goodsInfo.remark.split(',').map((v, i) => {
                    arr.push({ text: v, value: i + 1 })
                })
            }
            return arr
        },
    },
    methods: {
        getType(str) {
            return str.split('#')[0] || ''
        },
        getPrice(str) {
            return str.split('#')[1] || ''
        },
        onConfirm() {
            if (!this.checked) {
                return this.$toast('请选择规格')
            }
            this.$emit('select', this.checked)
            this.show = false
        },
    },
    created() {
        // this.isBack = this.$route.query.isBack
        // console.log(this.isBack)
    },
}
</script>
<style lang="less" scoped>
.pop-sku-wrap {
    .title {
        font-size: 16px;
        text-align: center;
        font-weight: bold;
        padding: 10px;
    }
    .main {
        padding: 10px;
    }
    .info {
        display: flex;

        align-items: center;
        margin-bottom: 30px;
        .cover {
            width: 80px;
            height: 50px;
            margin-right: 10px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 5px;
            }
        }
    }
    .checkbox {
        display: flex;
        .active {
            background: #fffaee !important;
            border: 1px solid #fbd13d;
            // color: #FBD13D;
        }
        .check-btn {
            background: #f5f6f8;
            flex: 1;
            padding: 10px;
            text-align: center;
            width: 100%;
            border-radius: 4px;

            // line-height: 40px;
            // background: #f5f6f8;
        }
        .van-radio-group {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
        }
        .van-radio {
            // flex: 1;
            width: 300px;
            margin-right: 10px;
            margin-bottom: 10px;
        }
        /deep/.van-radio__icon {
            width: 0 !important;
        }
        /deep/.van-icon {
            display: block;
            box-sizing: border-box;
            width: 0 !important;
            height: 0 !important;
            color: transparent;
            font-size: 0.8em;
            line-height: 1.25;
            text-align: center;
            border: none;
            width: 100%;
        }
        /deep/.van-radio__label {
            margin: 0;
            color: #323233;
            line-height: 0.53333rem;
            width: 100%;
        }
    }
    .btn {
        line-height: 40px;
        height: 40px;

        background: #ff991d;
        border-radius: 20px;

        text-align: center;
        color: #fff;
        display: flex;

        justify-content: center;
        align-items: center;

        position: fixed;
        left: 10px;
        right: 10px;
        bottom: 30px;
    }
}
</style>
